import { Component } from '@angular/core';
import {
    FormBuilder,
    FormControl,
    FormGroup,
    Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { DropdownChangeEvent } from 'primeng/dropdown';
import { Tipos } from 'src/app/auth/register/interfaces/tipos';
import { DataService } from '../../services/shared/data.service';
import { RegistroService } from 'src/app/auth/register/services/registro-service';
import { forkJoin, Subscription } from 'rxjs';
import {
    TipoCatalogo,
    TipoCategoriaProfesion,
    TipoCategoriaProfesionPorAmbito,
    TipoProfesion,
} from '../../interfaces/tipos';
import { DatePipe } from '@angular/common';
import { RegistroProfesionalesService } from '../../services/registro-profesionales.service';
import Swal from 'sweetalert2';
import { ShowButtonService } from '../../../../../utils/services/show-button.service';
import { useEffect } from 'src/utils/useEffect';
import CONSTANTS from 'src/utils/resources/constants';

@Component({
    selector: 'app-solicitudes',
    templateUrl: './solicitudes.component.html',
    styleUrl: './solicitudes.component.scss',
    providers: [DatePipe],
})
export class SolicitudesComponent {
    formRegistroProfesional: FormGroup;

    minDate: Date = new Date(2000, 0, 1); // Año, Mes (0 = Enero), Día
    maxDate: Date = new Date();
    today: Date = new Date();
    tiposContacto: any[] = [];
    tiposDocumento: any[] = [];
    tiposDocumentoFiltered: any[] = [];
    tiposPersona: any[] = [];
    tiposUsuario: any[] = [];
    tipoAmbito: any[] = [];
    nivelAcademico: any[] = [];
    paises: any[] = [];
    profesion: any[] = [];
    categoriaProfesion: any[] = [];
    tiposFlujo: any[] = [];
    flujoTramite: any;
    procesoSeleccionado: any;
    profesionSeleccionada: any;
    clasificacionSeleccionada: any;
    flujoDetectado: any = null;
    public profesionesFiltradas: any[] = [];

    categoriaConProfesionesOriginal: any[] = [];
    categoriaConProfesiones: any[] = [];

    infoPersona: any = {}; // Simula datos de la persona logueada
    ambitoDetectado = 'Profesional';
    userSession: any = null;

    _showLoader = true;

    constructor(
        private fb: FormBuilder,
        private router: Router,
        private registroService: RegistroService,
        private registroProfesionalesService: RegistroProfesionalesService,
        private datePipe: DatePipe,
        private dataService: DataService,
        private showButtonService: ShowButtonService
    ) {
        this.formRegistroProfesional = this.fb.group({
            tiposNacionalidad: ['', Validators.required],
            tipoPersona: ['', Validators.required],
            paisEstudios: ['', Validators.required],
            tipoDocumento: ['', Validators.required],
            numeroDocumento: ['', Validators.required],
            nombres: ['', Validators.required],
            apellidos: ['', Validators.required],
            correo: ['', [Validators.required, Validators.email]],
            celular: ['', Validators.required],
            ambito: ['', Validators.required],
            nivelAcademico: [''],
            centroEstudios: [''],
            // profesion: ['', Validators.required],
            // categoriaProfesion: ['', Validators.required],
            titulo: [''],
            fechaGraduacion: [''],
            numRegistro: [''],
            fechaVencimiento: [''],
        });

        //ANALISIS DE MENSAJE ENVIADO DESDE FINALIZAR TRAMITE -------------------------------------
        useEffect(() => {
            const state = this.showButtonService.currentState();
            if (CONSTANTS.consoleEnabled) {
                console.log('Estado completo:', state);
            }
            if (state.visitado !== null && state.visitado === true) {
                this.showButtonService.changeVisitado(false);
                //Navegamos a la pantalla
                this.router.navigateByUrl(`/users/registro-profesionales`);
            }
        }, [() => this.showButtonService.currentState()]);
    }

    ngOnInit(): void {
        this.infoPersona = this.dataService.getValue('infoPersona');
        this.ambitoDetectado = this.dataService.getValue('ambitoDetectado');
        console.log('this.ambitoDetectado : ', this.ambitoDetectado);

        this.procesoSeleccionado = this.dataService.getValue(
            'procesoSeleccionado'
        );

        this.profesionSeleccionada = this.dataService.getValue(
            'profesionSeleccionada'
        );
               this.clasificacionSeleccionada = this.dataService.getValue(
            'clasificacionSeleccionada'
        );

        console.log('this.procesoSeleccionado : ', this.procesoSeleccionado);
        console.log('this.clasificacionSeleccionada : ', this.clasificacionSeleccionada);
        console.log(
            'this.profesionSeleccionada : ',
            this.profesionSeleccionada
        );

        this.flujoDetectado = this.dataService.getValue('procesoDetectado');
        // this.formRegistroProfesional = this.nuevoFormRegistroProfesional();

        this.loadData();
        const userSessionString = sessionStorage.getItem('userSession');

        if (userSessionString) {
            const userSession = JSON.parse(userSessionString);

            this.userSession = userSession;
        }
    }

    onBackClick() {
        this.router.navigate(['/ruta-anterior']);
    }

    private loadData() {
        forkJoin({
            tiposContacto: this.registroService.getTiposContacto(),
            tiposDocumento: this.registroService.getTiposDocumento(),
            tiposPersona: this.registroService.getTiposPersona(),
            tiposUsuario: this.registroService.getTiposUsuario(),
            nivelAcademico: this.registroService.getTiposNivelAcademico(),
            paises: this.registroService.getPaises(),
            profesion: this.registroService.getTiposProfesion(),
            categoriaProfesion:
                this.registroService.getTiposCategoriaProfesion(),
            tiposFlujo: this.registroService.getTiposFlujo(),
            tiposcategoriasConProfesiones:
                this.registroService.getTiposCategoriasConProfesiones(),
            flujoTramite: this.registroService.getCatalogoPorCodigo(
                this.flujoDetectado.bd_code
            ),
            tipoAmbito:
                this.registroService.getTiposCategoriasConProfesionesPorAmbito(),
        }).subscribe({
            next: (result) => {
                this.tiposContacto = result.tiposContacto.body;
                this.tiposDocumento = result.tiposDocumento.body;
                this.tiposDocumentoFiltered = this.tiposDocumento;
                this.tiposPersona = result.tiposPersona.body;
                this.tiposUsuario = result.tiposUsuario.body;
                this.tipoAmbito = result.tipoAmbito.body;
                this.nivelAcademico = result.nivelAcademico.body;
                this.paises = result.paises.body;
                this.profesion = result.profesion.body;
                this.categoriaProfesion = result.categoriaProfesion.body;
                this.tiposFlujo = result.tiposFlujo.body;
                this.flujoTramite = result.flujoTramite.body;

                this.categoriaConProfesionesOriginal =
                    result.tiposcategoriasConProfesiones.body;
                this.categoriaConProfesiones = [
                    ...this.categoriaConProfesionesOriginal,
                ];

                const defaultNacionalidad = this.paises.find(
                    (p) => p.codigoCatalogo === 'SV'
                );
                const defaultAmbito = this.tipoAmbito.find(
                    (p) => p.descripcionAmbito === this.ambitoDetectado
                );

                if (defaultNacionalidad) {
                    this.formRegistroProfesional.patchValue({
                        tiposNacionalidad: defaultNacionalidad.idCatalogo,
                        paisEstudios: defaultNacionalidad.idCatalogo,
                    });
                }

                if (defaultAmbito) {
                    this.formRegistroProfesional.patchValue({
                        ambito: defaultAmbito.idAmbito,
                    });
                    this.formRegistroProfesional.get('ambito')?.disable();

                    this.categoriaConProfesiones =
                        defaultAmbito.clasificaciones;
                    this.formRegistroProfesional
                        .get('categoriaProfesion')
                        ?.setValue(null);
                    this.formRegistroProfesional
                        .get('profesion')
                        ?.setValue(null);
                    this.profesionesFiltradas = [];

                    /** seleccionar por defecto cuando solo existe una categoría */
                    if (this.categoriaConProfesiones.length === 1) {
                        const unicaCategoria = this.categoriaConProfesiones[0];
                        this.formRegistroProfesional.patchValue({
                            categoriaProfesion: unicaCategoria.idClasificacion,
                        });
                        this.onChangeCategoriaProfesion({
                            value: unicaCategoria.idClasificacion,
                        });
                    }
                }

                this.aplicarConstraints();

                if (this.infoPersona) {
                    this.llenarFormularioDesdeInfoPersona();
                }
            },
            error: (error) => console.error(error),
        });
    }

    aplicarConstraints() {
        if (this.tiposContacto?.length) {
            const email = this.tiposContacto.find((t) =>
                t.tipo?.toLowerCase().includes('email')
            );
            const celular = this.tiposContacto.find((t) =>
                t.tipo?.toLowerCase().includes('telefono_celular')
            );

            if (email) {
                this.formRegistroProfesional
                    .get('correo')
                    ?.setValidators([
                        Validators.required,
                        Validators.email,
                        Validators.minLength(email.min),
                        Validators.maxLength(email.max),
                    ]);
            }

            if (celular) {
                this.formRegistroProfesional
                    .get('celular')
                    ?.setValidators([
                        Validators.required,
                        Validators.minLength(celular.min),
                        Validators.maxLength(celular.max),
                    ]);
            }

            this.formRegistroProfesional.updateValueAndValidity();
        }
    }

    guardarSolicitud() {
        console.log(
            'this.formRegistroProfesional.invalid : ',
            this.formRegistroProfesional.invalid
        );
        console.log(
            'this.formRegistroProfesional.value',
            this.formRegistroProfesional.value
        );

        console.log(
            'this.formRegistroProfesional.get(nivelAcademico) : ',
            this.formRegistroProfesional.get('nivelAcademico')?.value
        );

        const form = this.formRegistroProfesional.value;

        const fechaGraduacion = this.datePipe.transform(
            form.fechaGraduacion,
            'yyyy-MM-dd'
        );
        const fechaVencimiento = this.datePipe.transform(
            form.fechaVencimiento,
            'yyyy-MM-dd'
        );

        const payload = {
            idTipoPersona: this.infoPersona.idTipoPersona ?? null,
            idAmbitoRegistro:
                this.formRegistroProfesional.get('ambito')?.value ?? null,
            idProfesion: this.profesionSeleccionada.idProfesion ?? (form.profesion ?? null),
            idClasificacion: this.clasificacionSeleccionada.idClasificacion ?? (form.categoriaProfesion ?? null),
            idNivelAcademico:
                this.formRegistroProfesional.get('nivelAcademico')?.value ??
                null,
            tituloObtenido: form.titulo ?? null,
            fecGraduacion: fechaGraduacion ?? null,
            centroEstudios:
                this.formRegistroProfesional.get('centroEstudios')?.value ??
                null,
            paisEstudios: form.paisEstudios ?? null,
            numeroCarnetActual: form.numRegistro ?? null,
            fecVencimientoCarnetActual: fechaVencimiento ?? null,
            idNacionalidad: form.tiposNacionalidad ?? null,
            idFlujoTramite: this.flujoTramite.idCatalogo ?? null,
            session: {
                uniqueId: this.infoPersona.uniqueId,
                usuario: this.userSession.perfil.usuario,
                documento:
                    this.infoPersona.documentos.find(
                        (d: any) => d.principal === 1
                    )?.documento ?? null,
                correo:
                    this.infoPersona.contactos.find(
                        (c: any) => c.tipo === 'EMAIL'
                    )?.contacto ?? null,
            },
        };

        console.log('payload : ', payload);

        // return;
        if (
            this.formRegistroProfesional.invalid ||
            ((this.flujoDetectado.bd_code == 'UNIF' ||
                this.flujoDetectado.bd_code == 'RENOV') &&
                (!payload.fecVencimientoCarnetActual ||
                    !payload.numeroCarnetActual))
        ) {
            this.formRegistroProfesional.markAllAsTouched();
            const errorDetails: string[] = [];

            // Errores de validación de formulario
            Object.keys(this.formRegistroProfesional.controls).forEach(
                (key) => {
                    const control = this.formRegistroProfesional.get(key);
                    if (control?.invalid) {
                        const fieldName = this.getFieldDisplayName(key);
                        let errorMessage = `${fieldName}: `;

                        if (control.errors?.['required']) {
                            errorMessage += 'Este campo es obligatorio';
                        } else if (control.errors?.['email']) {
                            errorMessage += 'Ingrese un correo válido';
                        } else if (control.errors?.['minlength']) {
                            errorMessage += `Mínimo ${control.errors['minlength'].requiredLength} caracteres`;
                        } else if (control.errors?.['pattern']) {
                            errorMessage += 'Formato incorrecto';
                        } else {
                            errorMessage += 'Valor inválido';
                        }

                        errorDetails.push(errorMessage);
                    }
                }
            );

            // Validaciones adicionales para UNIF y RENOV
            if (
                this.flujoDetectado.bd_code == 'UNIF' ||
                this.flujoDetectado.bd_code == 'RENOV'
            ) {
                if (!payload.numeroCarnetActual) {
                    errorDetails.push(
                        'Número de Carnet: Este campo es obligatorio'
                    );
                }
                if (!payload.fecVencimientoCarnetActual) {
                    errorDetails.push(
                        'Fecha de Vencimiento: Este campo es obligatorio'
                    );
                }
            }

            Swal.fire({
                icon: 'warning',
                title: 'Formulario Incompleto',
                confirmButtonColor: '#3B82F6',
                denyButtonColor: '#343a40',
                html: `
                        <div class="text-left">
                            <p>Corrija los siguientes errores:</p>
                            <ul>
                            ${errorDetails
                                .map((err) => `<li>${err}</li>`)
                                .join('')}
                            </ul>
                        </div>
                        `,
                confirmButtonText: 'Entendido',
            });

            return;
        }

        Swal.fire({
            icon: 'question',
            showDenyButton: true,
            confirmButtonText: 'Si, confirmo',
            denyButtonText: 'No, cancelar',
            title: '¿Está seguro que desea guardar la Solicitud?',
            showCancelButton: false,
            confirmButtonColor: '#3B82F6',
            denyButtonColor: '#343a40',
        }).then((result) => {
            if (result.isConfirmed) {
                this._showLoader = true;
                this.registroProfesionalesService
                    .solicitudRegistroProfesional(payload)
                    .subscribe({
                        next: (response) => {
                            //Mostrar el mensaje para el siguiente modal de tramites
                            this.showButtonService.changeMessage(
                                'Solicitud guardada con exito'
                            );

                            //Se marca como visitado debido a que el usuario es enviado a esa pantalla
                            this.showButtonService.changeVisitado(false);

                            //Navegamos a la pantalla
                            this.router.navigateByUrl(
                                `/users/tramites/completar/fd/${response.idTramite}/${response.idProyecto}`
                            );
                        },
                        error: (error) =>
                            console.error(
                                'Error al hacer la solicitud:',
                                error
                            ),
                    });
            }
        });
    }

    private getFieldDisplayName(fieldKey: string): string {
        const fieldNames: { [key: string]: string } = {
            tipoPersona: 'Tipo de persona',
            tiposNacionalidad: 'Nacionalidad',
            tipoDocumento: 'Tipo de documento',
            numeroDocumento: 'Número de documento',
            nombres: 'Nombres',
            apellidos: 'Apellidos',
            celular: 'Teléfono celular',
            fijo: 'Teléfono fijo',
            correo: 'Correo electrónico',
            ambito: 'Ámbito profesional',
            nivelAcademico: 'Nivel académico',
            centroEstudios: 'Centro de estudios',
            paisEstudios: 'País de estudios',
            titulo: 'Título obtenido',
            fechaGraduacion: 'Fecha de graduación',
            // profesion: 'Profesión',
            // categoriaProfesion: 'Categoría de profesión',
            numRegistro: 'Número de registro',
            fechaVencimiento: 'Fecha de vencimiento',
        };

        return fieldNames[fieldKey] || fieldKey;
    }

    llenarFormularioDesdeInfoPersona(): void {
        if (!this.infoPersona) return;

        // Extraer contactos
        const celular =
            this.infoPersona.contactos.find(
                (c: any) => c.tipo === 'TELEFONO_CELULAR'
            )?.contacto ?? null;
        const correo =
            this.infoPersona.contactos.find((c: any) => c.tipo === 'EMAIL')
                ?.contacto ?? null;

        // Documento principal
        const documentoPrincipal = this.infoPersona.documentos.find(
            (d: any) => d.principal === 1
        );
        const documento = documentoPrincipal?.documento ?? null;

        const tipoPersona =
            this.tiposPersona.find(
                (t) => t.idTipoPersona === this.infoPersona.idTipoPersona
            ) ?? null;
        const tipoDocumento =
            this.tiposDocumento.find(
                (t) => t.idTipoDocumento === documentoPrincipal?.idTipoDocumento
            ) ?? null;

        // Habilitar campos
        this.formRegistroProfesional.get('numeroDocumento')?.enable();
        this.formRegistroProfesional.get('nombres')?.enable();
        this.formRegistroProfesional.get('apellidos')?.enable();
        this.formRegistroProfesional.get('celular')?.enable();
        this.formRegistroProfesional.get('fijo')?.enable();
        this.formRegistroProfesional.get('correo')?.enable();

        // Llenar el formulario
        setTimeout(() => {
            this.formRegistroProfesional.patchValue({
                tipoPersona: tipoPersona,
                tipoDocumento: tipoDocumento,
                nombres: this.infoPersona.nombres,
                apellidos: this.infoPersona.apellidos,
                celular: celular,
                correo: correo,
            });
        }, 0);

        // Paso 2: luego de un breve tiempo, setear el documento
        setTimeout(() => {
            this.formRegistroProfesional.patchValue({
                numeroDocumento: documento,
            });
        }, 0);

        console.log('tipoPersona : ', tipoPersona);

        this.formRegistroProfesional.get('tipoPersona')?.disable();
        this.formRegistroProfesional.get('tipoDocumento')?.disable();
        this.formRegistroProfesional.get('nombres')?.disable();
        this.formRegistroProfesional.get('apellidos')?.disable();
        this.formRegistroProfesional.get('numeroDocumento')?.disable();
        this.formRegistroProfesional.get('correo')?.disable();
        this.formRegistroProfesional.get('celular')?.disable();

        this._showLoader = false;
    }

    isNit() {
        return (
            this.formRegistroProfesional.get('tipoDocumento')?.value
                ?.idTipoDocumento == 2
        );
    }

    onChangeTipoDocumento($event: DropdownChangeEvent) {
        if ($event.value === null) {
            return;
        }

        // Filtrar solo si es NIT, sin tocar tipoPersona
        if ($event.value.idTipoDocumento === 2) {
            this.filtrarNit();
        } else {
            this.tiposDocumento = this.tiposDocumentoFiltered;
        }

        // Resetear solo número de documento
        this.formRegistroProfesional.patchValue({ numeroDocumento: null });

        // Ajustar campos según restricciones (ej. mostrar solo números, validar formato)
        this.restringirNit();
    }

    private filtrarNit() {
        let nit = this.tiposDocumento.filter((t) =>
            t.nombre.toLowerCase().includes('nit')
        )[0];
        this.tiposDocumento = [];
        this.tiposDocumento.push(nit);
        return nit;
    }
    private restringirNit() {
        if (this.isNit()) {
            this.formRegistroProfesional.get('apellidos')?.setValue('');
            this.formRegistroProfesional.get('apellidos')?.disable();
            this.formRegistroProfesional.get('apellidos')?.setValidators([]);
        } else {
            this.formRegistroProfesional.get('apellidos')?.enable();
            this.formRegistroProfesional
                .get('apellidos')
                ?.setValidators([Validators.required]);
        }
        this.formRegistroProfesional.enable();
        this.formRegistroProfesional.updateValueAndValidity();
        this.formRegistroProfesional.clearValidators();
    }

    onClearTipoPersona($event: Event): void {
        this.tiposDocumento = this.tiposDocumentoFiltered;
        this.formRegistroProfesional.clearValidators();
        this.formRegistroProfesional = this.nuevoFormRegistroProfesional();
    }

    nuevoFormRegistroProfesional() {
        return this.fb.group({
            tipoPersona: new FormControl<number | null>(
                { value: null, disabled: true },
                [Validators.required]
            ),
            tiposNacionalidad: new FormControl<number | null>(
                { value: null, disabled: false },
                [Validators.required]
            ),
            tipoDocumento: new FormControl<number | null>(
                { value: null, disabled: true },
                [Validators.required]
            ),
            numeroDocumento: new FormControl<number | null>(
                { value: null, disabled: true },
                [Validators.required]
            ),
            nombres: new FormControl<string | null>(
                { value: null, disabled: true },
                [Validators.required]
            ),
            apellidos: new FormControl<string | null>({
                value: null,
                disabled: true,
            }),
            celular: new FormControl<number | null>(
                { value: null, disabled: true },
                [Validators.required]
            ),
            fijo: new FormControl<number | null>({
                value: null,
                disabled: true,
            }),
            correo: new FormControl({ value: null, disabled: true }, [
                Validators.required,
                Validators.email,
            ]),

            ambito: new FormControl<number | null>(null, [Validators.required]),

            nivelAcademico: new FormControl<number | null>(null),

            centroEstudios: new FormControl({
                value: null,
                disabled: false,
            }),
            paisEstudios: new FormControl<number | null>(null),
            titulo: new FormControl({
                value: null,
                disabled: false,
            }),
            fechaGraduacion: new FormControl({
                value: null,
                disabled: false,
            }),
            profesion: new FormControl<number | null>(null, [
                Validators.required,
            ]),
            categoriaProfesion: new FormControl<number | null>(null, [
                Validators.required,
            ]),
            numRegistro: new FormControl({
                value: null,
                disabled: false,
            }),
            fechaVencimiento: new FormControl({
                value: null,
                disabled: false,
            }),
        });
    }
    onChangeTipoPersona($event: DropdownChangeEvent) {
        if ($event.value === null) {
            // Si limpian el tipoPersona, mostramos todas las categorías
            this.categoriaConProfesiones = [
                ...this.categoriaConProfesionesOriginal,
            ];
            return;
        }

        let tipoDocumento: Tipos;
        this.tiposDocumento = this.tiposDocumentoFiltered;

        if ($event.value.idTipoPersona === 1) {
            // DUI as default
            tipoDocumento = this.tiposDocumento.filter((t) =>
                t.nombre.toLowerCase().includes('dui')
            )[0];
        } else if ($event.value.idTipoPersona === 2) {
            // NIT as default
            tipoDocumento = this.filtrarNit();
        }

        if ($event.value.idTipoPersona === 2) {
            this.categoriaConProfesiones =
                this.categoriaConProfesionesOriginal.filter(
                    (c) => c.idClasificacion === 2
                );
        } else {
            this.categoriaConProfesiones = [
                ...this.categoriaConProfesionesOriginal,
            ];
        }

        this.formRegistroProfesional.patchValue({
            tipoDocumento: tipoDocumento!,
            categoriaProfesion: null, // opcional: resetea el valor seleccionado
        });

        this.formRegistroProfesional.enable();
        this.restringirNit();
    }

    onChangeAmbito(event: any): void {
        const idAmbitoSeleccionado = event.value;

        const ambitoSeleccionado = this.tipoAmbito.find(
            (a) => a.idAmbito === idAmbitoSeleccionado
        );

        if (ambitoSeleccionado) {
            this.categoriaConProfesiones = ambitoSeleccionado.clasificaciones;
            this.formRegistroProfesional
                .get('categoriaProfesion')
                ?.setValue(null);
            this.formRegistroProfesional.get('profesion')?.setValue(null);
            this.profesionesFiltradas = [];

            // Aquí setear si solo hay una categoria
            if (this.categoriaConProfesiones.length === 1) {
                const unicaCategoria = this.categoriaConProfesiones[0];
                this.formRegistroProfesional.patchValue({
                    categoriaProfesion: unicaCategoria.idClasificacion,
                });
                this.onChangeCategoriaProfesion({
                    value: unicaCategoria.idClasificacion,
                });
            }
        } else {
            this.categoriaConProfesiones = [];
            this.profesionesFiltradas = [];
            this.formRegistroProfesional
                .get('categoriaProfesion')
                ?.setValue(null);
            this.formRegistroProfesional.get('profesion')?.setValue(null);
        }
    }

    onChangeCategoriaProfesion(event: any): void {
        const idClasificacionSeleccionada = event.value;

        const categoriaSeleccionada = this.categoriaConProfesiones.find(
            (c) => c.idClasificacion === idClasificacionSeleccionada
        );

        if (categoriaSeleccionada) {
            this.profesionesFiltradas = categoriaSeleccionada.profesiones;
            // Limpiar la selección anterior de profesión
            this.formRegistroProfesional.get('profesion')?.setValue(null);
        } else {
            this.profesionesFiltradas = [];
            this.formRegistroProfesional.get('profesion')?.setValue(null);
        }
    }

    get nivelAcademicoFiltrado() {
        if (this.infoPersona?.idTipoPersona === 2) {
            return this.nivelAcademico.filter(
                (item) => item.alias1 === 'Juridica'
            );
        }
        return this.nivelAcademico;
    }

    titleCase(str: string): string {
        return str
            .toLowerCase()
            .split(' ')
            .map((word) => {
                if (word.length === 0) return word;
                const firstChar = word[0];
                // Si empieza con paréntesis, capitaliza el segundo carácter
                if (firstChar === '(' && word.length > 1) {
                    return '(' + word[1].toUpperCase() + word.slice(2);
                }
                return firstChar.toUpperCase() + word.slice(1);
            })
            .join(' ');
    }
}
